import { useAtom } from "jotai";

import isBopisModalOpenAtom from "../jotai/atoms/isBopisModalOpenAtom";

const useIsBopisModalOpen = () => {
  const [isBopisModalOpen, setIsBopisModalOpen] = useAtom(isBopisModalOpenAtom);

  return { isBopisModalOpen, setIsBopisModalOpen };
};

export default useIsBopisModalOpen;
